<template>
    <v-dialog v-model="show_dialog" scrollable persistent max-width="600px" :fullscreen="$vuetify.breakpoint.smAndDown">
        <v-card>
            <v-card-title
                    class="headline blue darken-2 white--text"
            >
                <div>{{$t('event.activity')}}</div>
            </v-card-title>
            <v-card-text class="v-dialog-body">


                <div class="progress-bar-wrapper" v-if="loading">
                    <v-progress-circular
                            indeterminate
                            color="primary"
                    ></v-progress-circular>
                </div>

                <div v-else>
                    <v-list two-line>
                        <v-list-tile>
                            <v-list-tile-content>
                                <v-list-tile-title>{{$t('event.activity_name')}}</v-list-tile-title>
                                <v-list-tile-sub-title>{{activity_item.name}}</v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                            <v-list-tile-content>
                                <v-list-tile-title>{{$t('event.activity_quota')}}</v-list-tile-title>
                                <v-list-tile-sub-title>{{activity_item.attendee_count}} / <template v-if="activity_item.quota">{{activity_item.quota}}</template><template v-else>{{$t('general.unlimited')}}</template></v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                    <div class="px-3" v-if="activity_item.registration_info.length">
                        <p class="item-label">{{$t('event.registrations')}}</p>
                        <v-list class="elevation-1">
                            <template v-for="(item) in activity_item.registration_info">
                                <v-list-tile>
                                    <v-list-tile-avatar>
                                        <v-icon>list_alt</v-icon>
                                    </v-list-tile-avatar>
                                    <v-list-tile-title>{{item.contact_name}} <span v-if="item.quantity > 1">({{item.quantity}})</span></v-list-tile-title>
                                </v-list-tile>
                            </template>
                        </v-list>
                    </div>
                </div>


            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="close_dialog">{{$t('action.close')}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {UrlServices} from "~/utils/url-manager"
    import RequestHandler from '~/utils/request-handler'

    export default {
        name: "ViewActivityDialog",
        props: {
            activity_id: Number,
            show_dialog: Boolean,
        },
        data() {
            return {
                loading: true,
                activity_item: {
                    name: null,
                    registration_info: []
                }
            };
        },
        methods: {
            getActivityById(activity_id) {
                let me = this;
                this.loading = true;
                RequestHandler.Get(UrlServices.createUrl({name: 'api_event_activity_view'}), {
                    activity_id: activity_id
                }, {
                    'success': function(data) {
                        me.activity_item = data.activity_data;
                    },
                    'complete': function() {
                        me.loading = false;
                    }
                });
            },
            close_dialog() {
                this.$emit('update:show_dialog', false);
            }
        },
        watch: {
            activity_id: function(activity_id) {
                this.getActivityById(activity_id);
            }
        }
    }
</script>

<style scoped>
    .progress-bar-wrapper {
        text-align: center;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .item-label {
        font-size: 16px;
        margin-bottom: 6px;
    }
</style>